<template>
  <el-dialog :title="$t('signRule.addTitle')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="addSignRuleInfo" label-width="120px" :rules="rules" class="text-left">
      <el-form-item :label="$t('signRule.table.ruleName')" prop="ruleName">
        <el-input v-model="addSignRuleInfo.ruleName" :placeholder="$t('signRule.placeholder.ruleName')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.cycleDays')" prop="cycleDays">
        <el-input-number v-model="addSignRuleInfo.cycleDays" :min="1" :max="365"
          :placeholder="$t('signRule.placeholder.cycleDays')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.rewardAmount')" prop="rewardAmount">
        <el-input-number v-model="addSignRuleInfo.rewardAmount" :min="0"
          :placeholder="$t('signRule.placeholder.rewardAmount')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.extraRewardAmount')" prop="extraRewardAmount">
        <el-input-number v-model="addSignRuleInfo.extraRewardAmount" :min="0"
          :placeholder="$t('signRule.placeholder.extraRewardAmount')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.remark')" prop="remark">
        <el-input v-model="addSignRuleInfo.remark" type="textarea" :rows="3"
          :placeholder="$t('signRule.placeholder.remark')" maxlength="512" show-word-limit />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="addSignRule">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveSignRule } from '@/api/admin/sign/signRuleApi'

export default {
  name: 'AddSignRule',
  data() {
    return {
      dialogVisible: false,
      addSignRuleInfo: {
        ruleName: '',
        cycleDays: 7,
        rewardAmount: 0,
        extraRewardAmount: 0,
        remark: ''
      },
      rules: {
        ruleName: [
          { required: true, message: this.$t('signRule.ruleNameRequired'), trigger: 'blur' }
        ],
        cycleDays: [
          { required: true, message: this.$t('signRule.cycleDaysRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.addSignRuleInfo = {
          ruleName: '',
          cycleDays: 7,
          rewardAmount: 0,
          extraRewardAmount: 0,
          remark: ''
        }
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    async addSignRule() {
      try {
        await this.$refs.form.validate()
        await saveSignRule(this.addSignRuleInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveFailed'))
        console.error('保存失败:', error)
      }
    }
  }
}
</script>
